import React, { } from 'react'
import { Grid, Card } from '@mui/material'
import { Button } from '../../Common/ui/button'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import { BiSolidFilePdf } from 'react-icons/bi'
import '../../Styles/ViewRisk.css'

const ViewRisk = ({ RiskDetailsById }) => {
    const { t } = useTranslation()

    const handleScore = () => {
    }

    // const handleClose = () => {
    //     // close button logic
    // }
    const formattedCreatedOn = dayjs(RiskDetailsById?.createdDate).format('D/MM/YYYY')
    const formattedIdentifiedOn = dayjs(RiskDetailsById?.identifiedOn).format('D/MM/YYYY')

    return (
        <div className='view-risk-container'>
            <Card className='m-4 p-5' sx={{ overflow: 'auto' }}>
                <div className="flex items-center">
                    <h3 className="text-lg font-semibold text-primary m-2">{t('Risk Summary')}</h3>
                    <div className="border-b border-gray-300 text-muted flex-grow w-6"></div>
                </div>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={2}>
                        <h3 className="text font-semibold text-black ml-2 mt-3">{t('Risk created by')}</h3>
                    </Grid>
                    <Grid item xs={12} sm={1}>
                        <div aria-label="" role="img" className="initials-avatar"><div>JR</div></div>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <div className="text font-semibold text-primary">{RiskDetailsById && RiskDetailsById.name}</div>
                        <div className="text text-black">{RiskDetailsById && RiskDetailsById.department}</div>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <div className="text font-semibold text-primary">{t('Department')}</div>
                        <div className="text text-black">{RiskDetailsById && RiskDetailsById.department}</div>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <div className="text font-semibold text-primary">{t('Created Date')}</div>
                        <div className="text text-black">{formattedCreatedOn}</div>
                    </Grid>
                </Grid>
                <div className="border-b border-gray-300 mt-5 text-muted flex-grow"></div>
                <Grid container spacing={2} marginTop={4}>
                    <Grid item xs={12} sm={3}>
                        <div className="text font-semibold text-black m-2">{t('Risk Title')}</div>
                        <div className='m-2'>{RiskDetailsById?.title}</div>
                        <div className="border-b border-gray-300 m-2 text-muted flex-grow"></div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <div className="text font-semibold text-black m-2">{t('Description')}</div>
                        <div className='m-2 text-muted'>{RiskDetailsById?.description}</div>
                        <div className="border-b border-gray-300 m-2 text-muted flex-grow"></div>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <div className="text font-semibold text-black m-2">{t('Identified On')}</div>
                        <div className='m-2'>{formattedIdentifiedOn}</div>
                        <div className="border-b border-gray-300 m-2 text-muted flex-grow"></div>
                    </Grid>
                </Grid>
                <Grid container spacing={2} marginTop={4}>
                    <Grid item xs={12} sm={3}>
                        <div className="text font-semibold text-black m-2">{t('Source of Risk')}</div>
                        <div className='m-2'>{RiskDetailsById?.sourceRiskId}</div>
                        <div className="border-b border-gray-300 m-2 text-muted flex-grow"></div>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <div className="text font-semibold text-black m-2">{t('Risk Nature')}</div>
                        <div className='m-2 text-muted'>{RiskDetailsById?.type}</div>
                        <div className="border-b border-gray-300 m-2 text-muted flex-grow"></div>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <div className="text font-semibold text-black m-2">{t('Category')}</div>
                        <div className='m-2 text-muted'>{RiskDetailsById?.category}</div>
                        <div className="border-b border-gray-300 m-2 text-muted flex-grow"></div>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <div className="text font-semibold text-black m-2">{t('Impacted Department')}</div>
                        <div className='m-2'>{RiskDetailsById?.impactedDepartment?.join(',\n')}</div>
                        <div className="border-b border-gray-300 m-2 text-muted flex-grow"></div>
                    </Grid>
                </Grid>
                <Grid container spacing={2} marginTop={4}>
                    <Grid item xs={12} sm={6}>
                        <div className="text font-semibold text-black m-2">{t('Impact Of Risk')}</div>
                        <div className='m-2'>{RiskDetailsById?.impactOfRisk}</div>
                        <div className="border-b border-gray-300 m-2 text-muted flex-grow"></div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <div className="text font-semibold text-black m-2">{t('Suggested Mitigation')}</div>
                        <div className='m-2 text-muted'>{RiskDetailsById?.suggestedMitigation}</div>
                        <div className="border-b border-gray-300 m-2 text-muted flex-grow"></div>
                    </Grid>
                </Grid>
                <Grid container spacing={2} marginTop={4}>
                    <Grid item xs={12} sm={6}>
                        <div className="text font-semibold text-black m-2">{t('Supporting Documents')}</div>
                        <div className='m-2 flex'>
                            { RiskDetailsById?.supportingDocuments && RiskDetailsById?.supportingDocuments.map((doc, index) => (
                                <div key={index} className='flex m-2'>
                                    <BiSolidFilePdf style={{ fontSize: '20px', color: 'hsl(var(--destructive))' }} />
                                    <Link className='text-primary' to={doc.url} target="_blank">
                                        {doc?.fileName}
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <div className="text font-semibold text-black m-2">{t('Risk Owner')}</div>
                        <div className="text text-black m-2">{RiskDetailsById?.ownerDepartmentId}</div>
                        <div className="border-b border-gray-300 m-2 text-muted flex-grow"></div>
                    </Grid>
                    <Grid item xs={12} sm={3} />
                </Grid>
                <div className="flex items-center mt-5">
                    <h3 className="text-lg font-semibold text-primary m-2">{t('Risk Scoring')}</h3>
                    <div className="border-b border-gray-300 ml-4 mr-4 text-muted flex-grow"></div>
                </div>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={3}>
                        <Button variant="outline" onClick={handleScore} className="m-3">
                            {t('See Score')}
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <div className='flex m-2'>
                            <div className="text font-semibold text-primary m-2">{t('Impact')} :</div>
                            <div className='m-2'>{RiskDetailsById.impact}</div>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <div className='flex mt-2'>
                            <div className="text font-semibold text-primary m-2">{t('Probability')} :</div>
                            <div className='m-2'>{RiskDetailsById.probability}</div>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <div className='flex m-2'>
                            <div className="text font-semibold text-primary m-2">{t('Risk Score')} :</div>
                            <div className='m-2'>{RiskDetailsById.riskScore}</div>
                        </div>
                    </Grid>
                </Grid>
                {/* <div className="flex items-center mt-5 mb-5">
                    <h3 className="text-lg font-semibold text-primary m-2">{t('Mitigation Plan')}</h3>
                    <div className="border-b border-gray-300 ml-4 mr-4 text-muted flex-grow"></div>
                </div>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={3}>
                        <div className='m-2'>
                            <div className="text font-semibold text-primary m-2">{t('Measures')}</div>
                            <div className='m-2'>{RiskDetailsById?.mitigation?.measuresId}</div>
                            <div className="border-b border-gray-300 m-2 text-muted flex-grow"></div>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <div className='m-2'>
                            <div className="text font-semibold text-primary m-2">{t('Description')}</div>
                            <div className='m-2'>{RiskDetailsById?.mitigation?.mitigationDescription}</div>
                            <div className="border-b border-gray-300 m-2 text-muted flex-grow"></div>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <div className='m-2'>
                            <div className="text font-semibold text-primary m-2">{t('Mitigation Budget')}</div>
                            <div className='m-2'>&#8377;{RiskDetailsById?.mitigation?.mitigationBudget}</div>
                            <div className="border-b border-gray-300 m-2 text-muted flex-grow"></div>
                        </div>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={3}>
                        <div className='m-2'>
                            <div className="text font-semibold text-primary m-2">{t('Available Amount')}</div>
                            <div className='m-2'>{RiskDetailsById?.mitigation?.availableAmount}</div>
                            <div className="border-b border-gray-300 m-2 text-muted flex-grow"></div>
                        </div>
                    </Grid>
                </Grid> */}
            </Card>
            {/* <div className="button-container flex justify-end mt-4 m-2">
                <Button variant="outline" onClick={handleClose} className="m-3">
                    {t('Cancel')}
                </Button>
            </div> */}
        </div>
    )
}

export default ViewRisk
